import { ChatWithRequestPane, RequestActionType } from '@strata/react-chat';
import { useEffect } from 'react';
import { useParams } from 'react-router';

import { ChatDetails } from 'components/requests/ChatDetails';
import { type RequestDetails } from 'services/interfaces';
import {
    usePostMarkRequestReadMutation,
    usePostRequestActivityMutation,
} from 'store/api/payerRequestApi';

interface OverviewTabProps {
    canWriteRequestType: boolean;
    isLoading: boolean;
    requestDetails?: RequestDetails;
}

export const OverviewTab = ({
    canWriteRequestType,
    isLoading,
    requestDetails = undefined,
}: OverviewTabProps) => {
    const { payerId, requestId } = useParams() as { payerId: string; requestId: string };

    const [postRequestActivity] = usePostRequestActivityMutation();

    // Once data loads, mark request as read
    const [postMarkRequestRead] = usePostMarkRequestReadMutation();
    useEffect(() => {
        if (!isLoading && requestId === requestDetails?.requestId && canWriteRequestType) {
            (() => postMarkRequestRead({ payerId, requestId }))();
        }
    }, [
        isLoading,
        requestDetails?.requestId,
        payerId,
        requestId,
        canWriteRequestType,
        postMarkRequestRead,
    ]);

    return (
        <ChatDetails
            requestDetails={requestDetails}
            canWriteRequestType={canWriteRequestType}
            isLoading={isLoading}
            conversationType={ChatWithRequestPane.ConversationType.CHAT}
            onMessageSend={async ({ details }) => {
                await postRequestActivity({
                    payerId,
                    requestId,
                    actionType: RequestActionType.MESSAGE,
                    actionDetail: details.message,
                }).unwrap();
            }}
        />
    );
};
